export default "__VITE_ASSET__CxzDf19f__"